import { useIntl } from '@capsicum/common';
import { BaseCheckboxInput as Checkbox } from '@capsicum/common-web';
import { type SelectionStepProps } from '@capsicum/features/regulations/shared';
import styled from 'styled-components';

export const SelectionStep = ({ categoryOptions, handleCheckbox }: SelectionStepProps) => {
	const { $t } = useIntl();

	return (
		<S.ContentContainer>
			<S.Title>{$t('sourceOfIncome.title')}</S.Title>
			<S.Subtitle>{$t('sourceOfIncome.text1')}</S.Subtitle>
			<S.Subtitle>{$t('sourceOfIncome.text2')}</S.Subtitle>
			<S.CheckboxesContainer>
				{categoryOptions.map(item => (
					<Checkbox
						key={item.value}
						testID={`source-of-income-category-checkbox-${item.value}`}
						onChange={e => handleCheckbox(e, item.value)}
					>
						<S.CheckboxText>{item.name}</S.CheckboxText>
					</Checkbox>
				))}
			</S.CheckboxesContainer>
		</S.ContentContainer>
	);
};

namespace S {
	export const ContentContainer = styled.div`
		display: flex;
		flex-direction: column;
	`;

	export const Title = styled.span`
		color: ${({ theme }) => theme.colors.text.main.enabled};
		${({ theme }) => theme.fonts.headings.title5};
		margin-bottom: ${({ theme }) => theme.spacings.small};
	`;

	export const Subtitle = styled.span`
		color: ${({ theme }) => theme.colors.text.main.enabled};
		${({ theme }) => theme.fonts.text.text3};
		margin-bottom: ${({ theme }) => theme.spacings.xsmall};
	`;

	export const CheckboxText = styled.span`
		color: ${({ theme }) => theme.colors.text.main.enabled};
		${({ theme }) => theme.fonts.text.text5};
	`;

	export const CheckboxesContainer = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxsmall};
		margin-top: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
